// Modulo-7 musical cryptogram with ascending octaves.
// A=0..G=6 in bass; H wraps to A one octave higher, etc.
// A starts at A2 — chosen so the full alphabet (A2..E6) fits a grand staff.

const NOTE_NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

export const isMusicalLetter = (ch) => /^[A-Za-z]$/.test(ch);

export function letterToNote(letter) {
  if (!isMusicalLetter(letter)) return null;
  const pos = letter.toUpperCase().charCodeAt(0) - 65; // 0..25
  const noteIdx = pos % 7;
  const octStep = Math.floor(pos / 7);
  const note = NOTE_NAMES[noteIdx];
  // C..G belong to the next musical octave (since octaves start at C, not A)
  const baseOctave = note === 'A' || note === 'B' ? 2 : 3;
  const octave = baseOctave + octStep;
  return { note, octave, pitch: `${note}${octave}` };
}

// Pitch (e.g. "A4", "Eb3", "F#5") -> frequency in Hz
export function pitchToFrequency(pitch) {
  const m = /^([A-G])([#b]?)(\d)$/.exec(pitch);
  if (!m) return 440;
  const [, n, acc, o] = m;
  const semitonesFromC = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
  let semitones = (parseInt(o, 10) - 4) * 12 + semitonesFromC[n] - semitonesFromC.A;
  if (acc === "#") semitones += 1;
  else if (acc === "b") semitones -= 1;
  return 440 * Math.pow(2, semitones / 12);
}
